module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_9005.c6a49e1c.png";